import {Text} from '@sanity/ui'
import {memo} from 'react'
import {styled} from 'styled-components'

export const ReleaseBadgeTextWrapper = memo(styled(Text)`
  white-space: pre-line;
`)
